<template>
	<div>
		<!--okta회원-->
		<div class="mypage-main" v-if="USER_TYPE === CONST.USER_TYPE.OKTA">
			<h1>내정보관리</h1>
			<div class="button-box">
				<button class="grayBtn mobile-hide" @click="reloadPage">취소</button>
				<button class="greenBtn mobile-hide" @click.prevent.stop="doSubmit">저장</button>
				<button class="lineBtn web-hide" @click="oktaInfo">내정보 수정하기</button>
			</div>
		</div>
		<!--채용기업-->
		<div class="mypage-main" v-if="USER_TYPE === CONST.USER_TYPE.COMPANY">
			<h1>내정보관리</h1>
			<div class="button-box">
				<button class="lineBtn web-hide" @click="oktaInfo">내정보 수정하기</button>
			</div>
			<!--			<div class="button-box">
				<button class="grayBtn" @click="$router.go(-1)">취소</button>
				<button class="pinkBtn" @click.once="doSubmit">저장</button>
			</div>-->
		</div>
		<okta :loginMember="loginMember" v-if="USER_TYPE === CONST.USER_TYPE.OKTA" :tab-type="viewType" />
		<sm :loginMember="loginMember" v-if="USER_TYPE === CONST.USER_TYPE.COMPANY" :tab-type="viewType" />
	</div>
</template>

<script>
import CONST from '@/constants';
import eventBus from '@/plugins/event-bus';
import okta from './Detail-Info-oktaUser';
import sm from '@/components/mypage/Detail-Info-company';

export default {
	title: '내정보관리 메인',
	name: 'MypageMain',
	props: ['viewType'],
	components: { okta: okta, sm: sm },
	data: function() {
		return {
			CONST,
			USER_TYPE: '',
			loginMember: null,
		};
	},
	created() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		this.USER_TYPE = this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY ? 'COMPANY' : 'OKTA';
	},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'MYPAGE');
	},
	computed: {},
	methods: {
		// goMenu: function() {
		// 	alert('어디로 가야되죠?');
		// },
		reloadPage: function() {
			window.location.reload();
		},
		doSubmit: function() {
			if (this.USER_TYPE === CONST.USER_TYPE.OKTA) {
				eventBus.$emit(CONST.EVENTS.SAVE_MYPAGE, CONST.USER_TYPE.OKTA);
				return false;
			} else if (this.USER_TYPE === CONST.USER_TYPE.COMPANY) {
				eventBus.$emit(CONST.EVENTS.SAVE_MYPAGE, CONST.USER_TYPE.COMPANY);
				return false;
			}
		},
		oktaInfo: function() {
			this.$session.set('userId', this.loginMember.userId);
			this.$device.pushView(CONST.CMS_SERVER + '/mypage/myMemberEdit.do' + '?userId=' + this.$apiClient.getApiToken());
		},
	},
};
</script>

<style scoped></style>
